import { sanitizeBoolString, sanitizeString } from '../utils';
import { ClientRequestType, ServerDriversRequestType } from './types';

export const transformChallengeCurrentCarrierRequest = (
  data: ClientRequestType
): ServerDriversRequestType => {
  return {
    biLevel: sanitizeString(data.currentInsuranceBiLevel),
    carrierName: sanitizeString(data.currentInsuranceCarrierName),
    insuredDuration: sanitizeString(data.currentInsuranceInsuredDuration),
    insured: sanitizeBoolString(data.isCurrentlyInsured),
    lapseDuration: sanitizeString(data.currentInsuranceLapseDuration),
    reasonText: sanitizeString(data.reasonText),
  };
};
